import script from "./comp_banda_logos.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_banda_logos.vue?vue&type=script&setup=true&lang=js"

import "./comp_banda_logos.vue?vue&type=style&index=0&id=427b8824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427b8824"]])

export default __exports__